import {
  FETCH_FORMULAIRES_FAILURE,
  FETCH_FORMULAIRES_REQUEST,
  FETCH_FORMULAIRES_SUCCESS,
} from "../Types";
import { notification } from "antd";
import { apiGet } from "../../services/apiInterceptor";

export const ListFormsActions = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_FORMULAIRES_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token
      const response = await apiGet("api/forms");

      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de la récupération des formulaires"
        );
      }

      dispatch({ type: FETCH_FORMULAIRES_SUCCESS, payload: data?.forms });
      return data;
    } catch (error) {
      dispatch({ type: FETCH_FORMULAIRES_FAILURE, payload: error?.message });

      notification.error({
        message:
          error?.message || "Erreur lors de la récupération des formulaires",
        duration: 5,
      });
    }
  };
};
